<template>
  <section class="ReShippingAddress" :class="{ 'step-show': isAuthenticated }" data-scroll="address">
    <div class="ShippingAddress_header flex-between">
      <h2 class="title">
        {{ $t('common.address.title.shipping', 'Shipping address') }}
      </h2>

      <checkout-nav :step-numer="2" v-if="isAuthenticated && !hasAddress" :step-count="navCount"/>

      <app-edit-button
        v-if="hasAddress && !hasSubscription"
        :editable="editable"
        :disabled="updateAddressTask.isActive"
        @click.native="editAddress"
        data-name="address-editButton"
      />
    </div>

    <div class="ShippingAddress_body">
      <div v-if="!hasSubscription && isAuthenticated">
        <form class="ShippingAddress_form " v-if="editable && !isShow">
          <section>
            <template v-if="currentCountryCode === 'US'">
              <div class="usDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="addition"
                  :errors="errorsFor('addition')"
                  data-name="editShippingAddress-addition"
                  autocomplete="shipping street-address"
                  autofocus="autofocus"
                  name="shippingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                />
                <div class="usDeliverAddress_label">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode [5 digit]', 'Zip code [5 digit]')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedCountry && selectedCountry.states"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchState"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showSelectLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.state', 'State') }} {{ error }}</p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'CA'">
              <div class="usDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="addition"
                  :errors="errorsFor('addition')"
                  data-name="editShippingAddress-addition"
                  autocomplete="shipping street-address"
                  autofocus="autofocus"
                  name="shippingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                />
                <div class="usDeliverAddress_label">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="countryProvinces && countryProvinces.provinces"
                    :class="{'error': errorsFor('selectedCountryProvince').length > 0}"
                  >
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.placeholder.province', 'Select your province') }}</label>
                    <app-select
                      v-if="countryProvinces"
                      v-model="selectedCountryProvince"
                      :options="countryProvinces.provinces"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchProvince"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showSelectLabel ? null : $t('common.address.placeholder.province', 'Select your province')"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedCountryProvince')"
                      :key="index"
                    >{{ $t('common.address.textLable.province', 'Province') }} {{ error }}</p>
                  </div>
                  <div
                    class="Re_form_group deliverAddress_city"
                    :class="{'error': errorsFor('selectedCountryCity').length > 0}"
                    @mouseover="mouseover()"
                    @mouseleave="mouseleave()"
                  >
                    <v-popover
                      class="city_poptip"
                      trigger="manual"
                      placement="bottom-right"
                      :open="isOpen"
                    >
                      <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.placeholder.city', 'Select your city') }}</label>
                      <app-select
                        v-if="countryProvinces"
                        v-model.trim="selectedCountryCity"
                        :options="countryProvinces.cities"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        open-direction="bottom"
                        label="name"
                        track-by="code"
                        :internal-search="false"
                        :id="selectedCountry.code"
                        @search-change="searchCity"
                        :disabled="updateAddressTask.isActive || !selectedCountryProvince"
                        @open="showLabel"
                        @close="validenableDisplayLabel"
                        :placeholder="showSelectLabel ? null : $t('common.address.placeholder.city', 'Select your city')"
                        :class="{'extend': showSelectLabel}"
                      >
                        <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                      </app-select>
                      <template slot="popover">
                        <div>{{ $t('common.address.placeholder.selectProvinceFirst', 'Please select the province first') }}</div>
                      </template>
                    </v-popover>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedCountryCity')"
                      :key="index"
                    >{{ $t('common.address.placeholder.city', 'City') }} {{ error }}</p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'GB'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine2"
                    name="shippingAddress-AddressLine2"
                    autocomplete="shipping address-line2"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('county').length > 0}">
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="county"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

             <template v-if="currentCountryCode === 'CZ'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required" 
                  /> 
                 
                </div>

                <div class="esDeliverAddress_belowLabel">
                    <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_county"
                    
                  />

                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  /> 
                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    class="deliverAddress_city"
                  /> 
                </div>
              </div>
            </template>


            <template v-if="currentCountryCode === 'IT'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required" 
                  />  
              
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county" 
                  />
                  </div>
                  <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    class="deliverAddress_city"
                  /> 

                  <!-- <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('stateCode').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="null"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingCounty')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div> -->

                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="selectedCountry && selectedCountry.states"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchState"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showSelectLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.state', 'State') }} {{ error }}</p>
                  </div>

                </div>
              </div>
            </template> 

            <template v-if="currentCountryCode === 'RO'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber" 
                  />
                  
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    class="deliverAddress_city"
                  />
                    <div 
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('county').length > 0}">
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'AT'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required" 
                  /> 
                 
                </div>

                <div class="esDeliverAddress_belowLabel">
                    <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_county"
                    
                  />

                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  /> 
                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    class="deliverAddress_city"
                  /> 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'FR' || currentCountryCode === 'SE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required" 
                  /> 

                  <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine2"
                    name="shippingAddress-AddressLine2"
                    autocomplete="shipping address-line2"
                    class="deliverAddress_line2"
                  />
                 
                </div>

                <div class="esDeliverAddress_belowLabel">
                    <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_county"
                    
                  />

                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  /> 
                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    class="deliverAddress_city"
                  /> 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'ES'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber" 
                  />
                  <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine2"
                    name="shippingAddress-AddressLine2"
                    autocomplete="shipping address-line2"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    class="deliverAddress_city"
                  />
                    <div 
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('county').length > 0}">
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'BE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required" 
                  /> 
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county" 
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    class="deliverAddress_city"
                  /> 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'PL'">
              <div class="plDeliverAddress">
                <div class="plDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    :errors="errorsFor('street')"
                    data-name="editShippingAddress-addition"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    name="shippingAddress-addition"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_addition"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                  />
                </div>
                <div class="plDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    :errors="errorsFor('extension')"
                    data-name="editShippingAddress-extension"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_extension"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'DE'">
              <div class="deDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="addition"
                  :errors="errorsFor('addition')"
                  data-name="editShippingAddress-addition"
                  autocomplete="shipping street-address"
                  autofocus="autofocus"
                  name="shippingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                />
                <div class="deDeliverAddress_belowLabels">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'NL'">
              <div class="nlDeliverAddress">
                <div class="nlDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    :errors="errorsFor('street')"
                    data-name="editShippingAddress-addition"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    name="shippingAddress-addition"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_street"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    :errors="errorsFor('extension')"
                    data-name="editShippingAddress-extension"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_extension"
                  />
                </div>
                <div class="nlDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <app-checkbox
              id="other-address"
              :label="$t('common.address.checkbox.hasBilling.label', 'I have a different billing address')"
              :value="hasBillingAddress"
              @input="hasBillingAddress = $event"
              :disabled="updateAddressTask.isActive"
              @click="trackConversion({name: 'interaction', description: `different_billing_address:${hasBillingAddress ? 'uncheck': 'check'}`})"
            />
          </section>
          <section class="billingAddress_form" v-if="hasBillingAddress">
            <div class="ShippingAddress_header">
              <h2 class="title">
                {{ $t('common.address.title.billing', 'billing address') }}
              </h2>
            </div>
            <template v-if="currentCountryCode === 'US'">
              <div class="usDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="billingAddition"
                  :errors="errorsFor('billingAddition')"
                  data-name="editBillingAddress-addition"
                  autocomplete="billing street-address"
                  autofocus="autofocus"
                  name="billingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                />
                <div class="usDeliverAddress_label">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editBillingAddress-zipCode"
                    autocomplete="billing postal-code"
                    name="billingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedBillingCountry && selectedBillingCountry.states"
                    :class="{'error': errorsFor('selectedBillingCountryState').length > 0}"
                  >
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedBillingCountryState"
                      :options="selectedBillingCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchState"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showSelectLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedBillingCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.state', 'State') }} {{ error }}</p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'CA'">
              <div class="usDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="billingAddition"
                  :errors="errorsFor('billingAddition')"
                  data-name="editBillingAddress-addition"
                  autocomplete="billing street-address"
                  autofocus="autofocus"
                  name="billingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                />
                <div class="usDeliverAddress_label">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editBillingAddress-zipCode"
                    autocomplete="billing postal-code"
                    name="billingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedBillingCountry && selectedBillingCountry.states"
                    :class="{'error': errorsFor('selectedBillingCountryProvince').length > 0}"
                  >
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.placeholder.province', 'Select your province') }}</label>
                    <app-select
                      v-model="selectedBillingCountryProvince"
                      :options="countryProvinces.provinces"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchProvince"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showSelectLabel ? null : $t('common.address.placeholder.province', 'Select your province')"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedBillingCountryProvince')"
                      :key="index"
                    >{{ $t('common.address.textLable.province', 'Province') }} {{ error }}</p>
                  </div>
                  <div
                    class="Re_form_group deliverAddress_city"
                    :class="{'error': errorsFor('selectedBillingCountryCity').length > 0}"
                    @mouseover="mouseover(true)"
                    @mouseleave="mouseleave(true)"
                  >
                    <v-popover
                      class="city_poptip"
                      trigger="manual"
                      placement="bottom-right"
                      :open="isBillingOpen"
                    >
                      <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.placeholder.city', 'Select your city') }}</label>
                      <app-select
                        v-if="countryProvinces"
                        v-model.trim="selectedBillingCountryCity"
                        :options="countryProvinces.billingCities"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                        open-direction="bottom"
                        label="name"
                        track-by="code"
                        :internal-search="false"
                        :id="selectedCountry.code"
                        @search-change="searchBillingCity"
                        :disabled="updateAddressTask.isActive || !selectedBillingCountryProvince"
                        @open="showLabel"
                        @close="validenableDisplayLabel"
                        :placeholder="showSelectLabel ? null : $t('common.address.placeholder.city', 'Select your city')"
                        :class="{'extend': showSelectLabel}"
                      >
                        <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                      </app-select>
                      <template slot="popover">
                        <div>{{ $t('common.address.placeholder.selectProvinceFirst', 'Please select the province first') }}</div>
                      </template>
                    </v-popover>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedBillingCountryCity')"
                      :key="index"
                    >{{ $t('common.address.placeholder.city', 'City') }} {{ error }}</p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'GB'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('billingLine2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine2"
                    name="billingAddress-AddressLine2"
                    autocomplete="billing address-line2"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('billingCounty').length > 0}">
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="billingCounty"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingCounty')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>


            <template v-if="currentCountryCode === 'CZ'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required" 
                  />
                  
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county"               
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                
                </div>
              </div>
            </template>

             <template v-if="currentCountryCode === 'IT'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required" 
                  /> 
                

                
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  </div>
                  <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  /> 
                  <!-- <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('billingStateCode').length > 0}">
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingCounty')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div> -->
                   <div
                    class="SelectGroup deliverAddress_country"
                    v-if="selectedBillingCountry && selectedBillingCountry.states"
                    :class="{'error': errorsFor('selectedBillingCountryState').length > 0}"
                  >
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedBillingCountryState"
                      :options="selectedBillingCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchState"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showSelectLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedBillingCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.state', 'State') }} {{ error }}</p>
                  </div>



                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'RO'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber" 
                  />
                 
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                    <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('billingStateCode').length > 0}">
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingStateCode')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'AT'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required" 
                  />
                  
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county"               
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'FR' || currentCountryCode === 'SE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required" 
                  />

                  <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('billingLine2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine2"
                    name="billingAddress-AddressLine2"
                    autocomplete="billing address-line2"
                    class="deliverAddress_line2"
                  />
                  
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county"               
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'ES'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber" 
                  />
                  <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('billingLine2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine2"
                    name="billingAddress-AddressLine2"
                    autocomplete="billing address-line2"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                    <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('billingStateCode').length > 0}">
                    <label class="typo__label" v-show="showSelectLabel">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showSelectLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :class="{'extend': showSelectLabel}"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingStateCode')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'BE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required" 
                  />  
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  /> 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'PL'">
              <div class="plDeliverAddress">
                <div class="plDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="billingStreet"
                    :errors="errorsFor('billingStreet')"
                    data-name="editShippingAddress-addition"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    name="shippingAddress-addition"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_addition"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                  />
                </div>
                <div class="plDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="billingExtension"
                    :errors="errorsFor('billingExtension')"
                    data-name="editShippingAddress-extension"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_extension"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'DE'">
              <div class="deDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="billingAddition"
                  :errors="errorsFor('billingAddition')"
                  data-name="editShippingAddress-addition"
                  autocomplete="shipping street-address"
                  autofocus="autofocus"
                  name="shippingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                  :top-label="topLabel"
                />
                <div class="deDeliverAddress_belowLabels">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'NL'">
              <div class="nlDeliverAddress">
                <div class="nlDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="billingStreet"
                    :errors="errorsFor('billingStreet')"
                    data-name="editShippingAddress-addition"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    name="shippingAddress-addition"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_street"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="billingExtension"
                    :errors="errorsFor('billingExtension')"
                    data-name="editShippingAddress-extension"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_extension"
                  />
                </div>
                <div class="nlDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>
          </section>
          <app-button
            type="submit"
            @click.prevent="updateAddressTask.run()"
            :is-loading="updateAddressTask.isActive"
            data-name="checkoutShippingAddress-updateButton"
            :disabled="!eabledButton"
          >
            {{ $t('checkout.button.next', 'Next') }}
          </app-button>
        </form>
        <form class="ShippingAddress_form" v-if="editable && isShow">
          <section>
            <template v-if="currentCountryCode === 'US' || currentCountryCode === 'CA'">
              <div class="usDeliverAddress">
                <r-app-text-input
                  v-if="selectedCountry && selectedCountry.street_housenumber_extension_field === 1"
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="addition"
                  :errors="errorsFor('addition')"
                  data-name="editShippingAddress-addition"
                  autocomplete="shipping street-address"
                  autofocus="autofocus"
                  name="shippingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                  :top-label="topLabel"
                />
                <div class="usDeliverAddress_label">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    v-if="currentCountryCode === 'US'"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'US'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchState"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.state', 'State') }} {{ error }}</p>
                  </div>
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'CA'"
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.province', 'Select your province') }}</label>
                    <app-select
                      v-model="selectedCountryProvince"
                      :options="countryProvinces.provinces"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchProvince"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.province', 'Select your province')"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.province', 'Province') }} {{ error }}</p>
                  </div>
                  <div
                    v-if="currentCountryCode === 'CA'"
                    class="Re_form_group deliverAddress_city"
                    :class="{'error': errorsFor('selectedCountryCity').length > 0}"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.city', 'Select your city') }}</label>
                    <app-select
                      v-if="countryProvinces"
                      v-model.trim="selectedCountryCity"
                      :options="countryProvinces.cities"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchCity"
                      :disabled="updateAddressTask.isActive || !selectedCountryProvince"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showSelectLabel ? null : $t('common.address.placeholder.city', 'Select your city')"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedCountryCity')"
                      :key="index"
                    >{{ $t('common.address.placeholder.city', 'City') }} {{ error }}</p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'GB'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine2"
                    name="shippingAddress-AddressLine2"
                    autocomplete="shipping address-line2"
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('county').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="county"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'CZ'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                   /> 
                  
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county"
                    :top-label="topLabel" 
                  />

                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>



               <template v-if="currentCountryCode === 'IT'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                   <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                   
                  /> 

                    <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                   </div>
                   <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  /> 
                  <!-- <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('stateCode').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div> -->

                 <div
                   class="SelectGroup deliverAddress_country"
                   
                    :class="{'error': errorsFor('selectedCountryState').length > 0}"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchState"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.state', 'State') }} {{ error }}</p>
                  </div>
                </div>
              </div>
            </template>

           <template v-if="currentCountryCode === 'RO'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                  
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('county').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

             <template v-if="currentCountryCode === 'AT'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                   /> 
                  
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county"
                    :top-label="topLabel" 
                  />

                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'FR' || currentCountryCode === 'SE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                   /> 
                   <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine2"
                    name="shippingAddress-AddressLine2"
                    autocomplete="shipping address-line2"
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                  
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                     class="deliverAddress_county"
                    :top-label="topLabel" 
                  />

                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'ES'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('line2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine2"
                    name="shippingAddress-AddressLine2"
                    autocomplete="shipping address-line2"
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('county').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'BE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('line1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-AddressLine1"
                    name="shippingAddress-AddressLine1"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel" 
                  />  
                </div>

                <div class="esDeliverAddress_belowLabel">
                    <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  /> 
                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :errors="errorsFor('city')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editShippingAddress-town"
                    name="shippingAddress-addressLevel1"
                    autocomplete="shipping address-level1"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  /> 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'PL'">
              <div class="plDeliverAddress">
                <div class="plDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    :errors="errorsFor('street')"
                    data-name="editShippingAddress-addition"
                    autocomplete="shipping street-address"
                    autofocus="autofocus"
                    name="shippingAddress-addition"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_addition"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                </div>
                <div class="plDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    :errors="errorsFor('extension')"
                    data-name="editShippingAddress-extension"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_extension"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'DE'">
              <div class="deDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="addition"
                  :errors="errorsFor('addition')"
                  data-name="editShippingAddress-addition"
                  autocomplete="shipping street-address"
                  autofocus="autofocus"
                  name="shippingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                  :top-label="topLabel"
                />
                <div class="deDeliverAddress_belowLabels">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'NL'">
              <div class="nlDeliverAddress">
                <div class="nlDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    :errors="errorsFor('street')"
                    data-name="editShippingAddress-addition"
                    autocomplete="shipping street-address"
                    name="shippingAddress-addition"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_street"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    :errors="errorsFor('houseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    :errors="errorsFor('extension')"
                    data-name="editShippingAddress-extension"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_extension"
                    :top-label="topLabel"
                  />
                </div>
                <div class="nlDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    :errors="errorsFor('zipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    :errors="errorsFor('city')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <app-checkbox
              class="order-last"
              id="other-address"
              :label="$t('common.address.checkbox.hasBilling.label', 'I have a different billing address')"
              :value="hasBillingAddress"
              @input="hasBillingAddress = $event"
              :disabled="updateAddressTask.isActive"
              @click="trackConversion({name: 'interaction', description: `different_billing_address:${hasBillingAddress ? 'uncheck': 'check'}`})"
            />
          </section>
          <section class="billingAddress_form" v-if="hasBillingAddress">
            <div class="ShippingAddress_header">
              <h2 class="title">
                {{ $t('common.address.title.billing', 'billing address') }}
              </h2>
            </div>
            <template v-if="currentCountryCode === 'US' || currentCountryCode === 'CA'">
              <div class="usDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="billingAddition"
                  :errors="errorsFor('billingAddition')"
                  data-name="editBillingAddress-addition"
                  autocomplete="billing street-address"
                  autofocus="autofocus"
                  name="billingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                  :top-label="topLabel"
                />
                <div class="usDeliverAddress_label">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editBillingAddress-zipCode"
                    autocomplete="billing postal-code"
                    name="billingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    v-if="currentCountryCode === 'US'"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedBillingCountry && selectedBillingCountry.states && currentCountryCode === 'US'"
                    :class="{'error': errorsFor('selectedBillingCountryState').length > 0}"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedBillingCountryState"
                      :options="selectedBillingCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchState"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="null"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedBillingCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.state', 'State') }} {{ error }}</p>
                  </div>
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedBillingCountry && countryProvinces.provinces && currentCountryCode === 'CA'"
                    :class="{'error': errorsFor('selectedBillingCountryState').length > 0}"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.province', 'Select your province') }}</label>
                    <app-select
                      v-model="selectedBillingCountryProvince"
                      :options="countryProvinces.provinces"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchProvince"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="null"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedBillingCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.province', 'Province') }} {{ error }}</p>
                  </div>
                  <div
                    v-if="currentCountryCode === 'CA'"
                    class="SelectGroup deliverAddress_city"
                    :class="{'error': errorsFor('billingCity').length > 0}"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.city', 'Select your city') }}</label>
                    <app-select
                      v-if="countryProvinces"
                      v-model.trim="selectedBillingCountryCity"
                      :options="countryProvinces.billingCities"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchCity"
                      :disabled="updateAddressTask.isActive || !selectedBillingCountryProvince"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showSelectLabel ? null : $t('common.address.placeholder.city', 'Select your city')"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('billingCity')"
                      :key="index"
                    >{{ $t('common.address.placeholder.city', 'City') }} {{ error }}</p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'GB'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('billingLine2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine2"
                    name="billingAddress-AddressLine2"
                    autocomplete="billing address-line2"
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('billingCounty').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="null"
                      v-model="billingCounty"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingCounty')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>


            <template v-if="currentCountryCode === 'CZ'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                   /> 
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    v-model.trim="billingHouseNumber"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :errors="errorsFor('billingHouseNumber')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_county"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
 
                </div>
              </div>
            </template>

           <template v-if="currentCountryCode === 'IT'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"                  
                  />  
                
                   <r-app-text-input
                    v-model.trim="billingHouseNumber"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :errors="errorsFor('billingHouseNumber')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_county"
                  />
                  </div>
                  <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  /> 
                  <!-- <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('billingStateCode').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="null"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingCounty')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div> -->

                  <div
                    class="SelectGroup deliverAddress_country"
                   
                    :class="{'error': errorsFor('selectedBillingCountryState').length > 0}"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedBillingCountryState"
                      :options="selectedBillingCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchState"
                      :disabled="updateAddressTask.isActive"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="null"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>
                    <p
                      class="tip-error"
                      v-for="(error, index) in errorsFor('selectedBillingCountryState')"
                      :key="index"
                    >{{ $t('common.address.textLable.state', 'State') }} {{ error }}</p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'RO'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    v-model.trim="billingHouseNumber"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :errors="errorsFor('billingHouseNumber')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_houseNumber"
                  />
                  
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                    <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('billingStateCode').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="null"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingStateCode')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

             <template v-if="currentCountryCode === 'AT'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                   /> 
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    v-model.trim="billingHouseNumber"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :errors="errorsFor('billingHouseNumber')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_county"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'FR' || currentCountryCode === 'SE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                   />
                   <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('billingLine2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine2"
                    name="billingAddress-AddressLine2"
                    autocomplete="billing address-line2"
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  /> 
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    v-model.trim="billingHouseNumber"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :errors="errorsFor('billingHouseNumber')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_county"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'ES'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    v-model.trim="billingHouseNumber"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :errors="errorsFor('billingHouseNumber')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_houseNumber"
                  />
                  <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :errors="errorsFor('billingLine2')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine2"
                    name="billingAddress-AddressLine2"
                    autocomplete="billing address-line2"
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                    <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties"
                    :class="{'error': errorsFor('stateCode').length > 0}">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="null"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      :disabled="updateAddressTask.isActive"
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend"
                    >
                      <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
                    </app-select>

                    <p class="tip-error" v-for="(error, index) in errorsFor('billingCounty')" :key="index">
                      {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
                    </p>
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'BE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :errors="errorsFor('billingLine1')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-AddressLine1"
                    name="billingAddress-AddressLine1"
                    autocomplete="billing street-address"
                    autofocus="autofocus"
                    required="required"
                    :top-label="topLabel" 
                  />  
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    v-model.trim="billingHouseNumber"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :errors="errorsFor('billingHouseNumber')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-houseNumber"
                    name="billingAddress-houseNumber"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_county"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    :disabled="updateAddressTask.isActive"
                    data-name="editBillingAddress-zipCode"
                    name="billingAddress-zipCode"
                    autocomplete="billing postal-code"
                    required="required"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editBillingAddress-city"
                    autocomplete="billing locality"
                    name="billingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  /> 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'PL'">
              <div class="plDeliverAddress">
                <div class="plDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="billingStreet"
                    :errors="errorsFor('billingStreet')"
                    data-name="editShippingAddress-addition"
                    autofocus="autofocus"
                    name="shippingAddress-addition"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_addition"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                </div>
                <div class="plDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="billingExtension"
                    :errors="errorsFor('billingExtension')"
                    data-name="editShippingAddress-extension"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_extension"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'DE'">
              <div class="deDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="billingAddition"
                  :errors="errorsFor('billingAddition')"
                  data-name="editShippingAddress-addition"
                  autocomplete="shipping street-address"
                  autofocus="autofocus"
                  name="shippingAddress-addition"
                  required="required"
                  :disabled="updateAddressTask.isActive"
                  :top-label="topLabel"
                />
                <div class="deDeliverAddress_belowLabels">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'NL'">
              <div class="nlDeliverAddress">
                <div class="nlDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="billingStreet"
                    :errors="errorsFor('billingStreet')"
                    data-name="editShippingAddress-addition"
                    autofocus="autofocus"
                    name="shippingAddress-addition"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_street"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    :errors="errorsFor('billingHouseNumber')"
                    data-name="editShippingAddress-houseNumber"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="billingExtension"
                    :errors="errorsFor('billingExtension')"
                    data-name="editShippingAddress-extension"
                    :disabled="updateAddressTask.isActive"
                    class="deliverAddress_extension"
                    :top-label="topLabel"
                  />
                </div>
                <div class="nlDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    :errors="errorsFor('billingZipCode')"
                    data-name="editShippingAddress-zipCode"
                    autocomplete="shipping postal-code"
                    name="shippingAddress-zipCode"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    :errors="errorsFor('billingCity')"
                    data-name="editShippingAddress-city"
                    autocomplete="shipping locality"
                    name="shippingAddress-city"
                    required="required"
                    :disabled="updateAddressTask.isActive"
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>
          </section>
          <app-button
            type="submit"
            @click.prevent="updateAddressTask.run()"
            :is-loading="updateAddressTask.isActive"
            data-name="checkoutShippingAddress-updateButton"
          >
            {{ $t('checkout.button.next', 'Next') }}
          </app-button>
        </form>
      </div>
      <div v-if="!isShow && hasSubscription">
        <form class="ShippingAddress_form" v-if="hasAddress">
          <section>
            <template v-if="currentCountryCode === 'US' || currentCountryCode === 'CA'">
              <div class="usDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="addition"
                  disabled
                  :top-label="topLabel"
                />
                <div class="usDeliverAddress_label">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    v-if="currentCountryCode === 'US'"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'US'"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchState"
                      disabled
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      class="extend hide_select"
                    />
                  </div>
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedCountry && selectedCountry.states && currentCountryCode === 'CA'"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.province', 'Select your province') }}</label>
                    <app-select
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchState"
                      disabled
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.province', 'Select your province')"
                      class="extend hide_select"
                    />
                  </div>
                  <r-app-text-input
                    v-if="currentCountryCode === 'CA'"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'GB'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="county"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      disabled
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend hide_select"
                    />
                  </div>
                </div>
              </div>
            </template>

           

            <template v-if="currentCountryCode === 'CZ'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                   /> 
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>



                <template v-if="currentCountryCode === 'IT'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel" 
                  />  

                    <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                   </div>
                   <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  /> 
                  <!-- <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      disabled
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend hide_select"
                    />
                  </div> -->

                  <div
                   class="SelectGroup deliverAddress_country"
                    
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedCountryState"
                      :options="selectedCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedCountry.code"
                      @search-change="searchState"
                      disabled
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      class="extend hide_select"
                    />
                  </div>
                </div>
              </div>
            </template>

           <template v-if="currentCountryCode === 'RO'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                 
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      disabled
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend hide_select"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'AT'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                   /> 
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'FR' || currentCountryCode === 'SE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                   /> 
                   <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'ES'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    v-model.trim="line2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="stateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      disabled
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend hide_select"
                    />
                  </div>
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'BE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="line1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel" 
                  />  
                </div>

                <div class="esDeliverAddress_belowLabel">
                    <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    v-model.trim="city"
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'PL'">
              <div class="plDeliverAddress">
                <div class="plDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_addition"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                </div>
                <div class="plDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    disabled
                    class="deliverAddress_extension"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'DE'">
              <div class="deDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="addition"
                  disabled
                  :top-label="topLabel"
                />
                <div class="deDeliverAddress_belowLabels">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'NL'">
              <div class="nlDeliverAddress">
                <div class="nlDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="street"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_street"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="houseNumber"
                    disabled
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="extension"
                    disabled
                    class="deliverAddress_extension"
                    :top-label="topLabel"
                  />
                </div>
                <div class="nlDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="zipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="city"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>
          </section>
          <section class="billingAddress_form" v-if="hasBillingAddress">
            <div class="ShippingAddress_header">
              <h2 class="title">
                {{ $t('common.address.title.billing', 'billing address') }}
              </h2>
            </div>
            <template v-if="currentCountryCode === 'US' || currentCountryCode === 'CA'">
              <div class="usDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="billingAddition"
                  disabled
                  :top-label="topLabel"
                />
                <div class="usDeliverAddress_label">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    v-if="currentCountryCode === 'US'"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedBillingCountry && selectedBillingCountry.states && currentCountryCode === 'US'"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedBillingCountryState"
                      :options="selectedBillingCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchState"
                      disabled
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      class="extend hide_select"
                    />
                  </div>
                  <div
                    class="SelectGroup deliverAddress_states"
                    v-if="selectedBillingCountry && selectedBillingCountry.states && currentCountryCode === 'CA'"
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.province', 'Select your province') }}</label>
                    <app-select
                      v-model="selectedBillingCountryState"
                      :options="selectedBillingCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchState"
                      disabled
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.province', 'Select your province')"
                      class="extend hide_select"
                    />
                  </div>
                  <r-app-text-input
                    v-if="currentCountryCode === 'CA'"
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'GB'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street and house number)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="billingCounty"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      disabled
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend hide_select"
                    />
                  </div>
                </div>
              </div>
            </template>



            <template v-if="currentCountryCode === 'CZ'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1*')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1*')"
                    disabled
                    :top-label="topLabel"
                   /> 
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>
    <template v-if="currentCountryCode === 'IT'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  /> 
 
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  </div>
                  <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <!-- <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.county', 'County*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.county', 'County*')"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      disabled
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend hide_select"
                    />
                  </div> -->

                    <div
                   class="SelectGroup deliverAddress_country"
                   
                  >
                    <label class="typo__label">{{ $t('common.address.placeholder.state', 'Select your state') }}</label>
                    <app-select
                      v-model="selectedBillingCountryState"
                      :options="selectedBillingCountry.states"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      label="name"
                      track-by="code"
                      :internal-search="false"
                      :id="selectedBillingCountry.code"
                      @search-change="searchState"
                      disabled
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      :placeholder="showLabel ? null : $t('common.address.placeholder.state', 'Select your state')"
                      class="extend hide_select"
                    />
                  </div>
                
                </div>
              </div>
            </template>

           <template v-if="currentCountryCode === 'RO'">
              <div class="gbDeliverAddress">
                <div class="gbDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                 
                </div>

                <div class="gbDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      disabled
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend hide_select"
                    />
                  </div>
                </div>
              </div>
            </template>
            <template v-if="currentCountryCode === 'AT'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                   /> 
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'FR' || currentCountryCode === 'SE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                   /> 
                   <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'ES'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line1"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    v-model.trim="billingLine2"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_line2"
                  />
                </div>

                <div class="esDeliverAddress_belowLabel">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                  <div
                    class="SelectGroup deliverAddress_country"
                    v-if="counties">
                    <label class="typo__label">{{ $t('common.address.textLabel&placeholder.stateCode', 'Provincia*') }}</label>
                    <app-select
                      :placeholder="showLabel ? null : $t('common.address.textLabel&placeholder.stateCode', 'Provincia*')"
                      v-model="billingStateCode"
                      :options="counties"
                      :searchable="true"
                      :allow-empty="false"
                      :show-labels="false"
                      open-direction="bottom"
                      disabled
                      :internal-search="false"
                      @search-change="searchCounty"
                      @open="showLabel"
                      @close="validenableDisplayLabel"
                      class="extend hide_select"
                    />
                  </div>
                </div>
              </div>
            </template>

             <template v-if="currentCountryCode === 'BE'">
              <div class="esDeliverAddress">
                <div class="esDeliverAddress_topLabel">
                  <r-app-text-input
                    v-model.trim="billingLine1"
                    :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    :placeholder="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1* (street)')"
                    disabled
                    :top-label="topLabel" 
                  />  
                </div>

                <div class="esDeliverAddress_belowLabel">
                   <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_county"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  /> 
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'PL'">
              <div class="plDeliverAddress">
                <div class="plDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="billingStreet"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_addition"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />
                </div>
                <div class="plDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="billingExtension"
                    disabled
                    class="deliverAddress_extension"
                    :top-label="topLabel"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'DE'">
              <div class="deDeliverAddress">
                <r-app-text-input
                  :label="$t('common.address.textLabel&placeholder.address', 'Address')"
                  :placeholder="$t('common.address.textLabel&placeholder.address', 'Address')"
                  v-model.trim="billingAddition"
                  disabled
                  :top-label="topLabel"
                />
                <div class="deDeliverAddress_belowLabels">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>

            <template v-if="currentCountryCode === 'NL'">
              <div class="nlDeliverAddress">
                <div class="nlDeliverAddress_topLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.street', 'Street')"
                    :placeholder="$t('common.address.textLabel&placeholder.street', 'Street')"
                    v-model.trim="billingStreet"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_street"
                  />
                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
                    v-model.trim="billingHouseNumber"
                    disabled
                    class="deliverAddress_houseNumber"
                    :top-label="topLabel"
                  />

                  <r-app-text-input
                    :placeholder="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
                    v-model.trim="billingExtension"
                    disabled
                    class="deliverAddress_extension"
                    :top-label="topLabel"
                  />
                </div>
                <div class="nlDeliverAddress_belowLabel flex">
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    :placeholder="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
                    v-model.trim="billingZipCode"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_zipCode"
                  />
                  <r-app-text-input
                    :label="$t('common.address.textLabel&placeholder.city', 'City')"
                    :placeholder="$t('common.address.textLabel&placeholder.city', 'City')"
                    v-model.trim="billingCity"
                    disabled
                    :top-label="topLabel"
                    class="deliverAddress_city"
                  />
                </div>
              </div>
            </template>
          </section>
        </form>
      </div>
    </div>
    <app-modal name="launchmodal" width="500px">
            <div class="v--modal-content">
              <div class="newFlowForCancelReplenishment_popUp">
                <h3 class="modal-title">
                 Oops! The Zip Code <span class="codeRed"> {{this.zipCode}} </span>  you entered does not match with the city <span class="codeRed"> {{this.city}} </span> and state <span class="codeRed"> {{this.selectedCountryState ? this.selectedCountryState.name : null}} </span> Do you want to proceed or edit ?
                </h3>
                <div class="modal-button-wrapper">
                  <app-button type="submit" 
                  data-name="continueUSzipcode" 
                   @click.prevent="continueaddress()"
                  > Continue </app-button>
                  <app-button 
                   data-name="modifyzipcode" 
                   @click.prevent="modify()"
                  type="submit"> Edit  </app-button>
                </div>
              </div>
            </div>
      </app-modal> 
  </section>
</template>

<script>
  import CheckoutNav from './CheckoutNav'
  import RePersonalAddressMixin from 'mixins/re-personal-address'
  import { mapState } from 'vuex'
  import { remove, startsWith } from 'lodash'
  import { extractErrorMessage } from '@/utilities/common'

  export default {
    name: 'checkout-address',

    components: {
      CheckoutNav
    },

    mixins: [RePersonalAddressMixin],

    props: {
      isAuthenticated: {
        type: Boolean,
        required: true
      },

      hasAddress: {
        type: Boolean,
        required: true
      },

      hasSubscription: {
        type: Boolean,
        required: true
      },

      bundles: {
        type: Array,
        required: true
      },

      previewBundle: {
        type: Array,
        required: true
      },

      bundlesWithQuantity: {
        type: Array,
        required: true
      }
    },

    data () {
      return {
        editable: !this.hasAddress,
        showSelectLabel: false,
        topLabel: true,
        isOpen: false,
        isBillingOpen: false
      }
    },

    computed: {
      ...mapState('checkout', {
        paymentRequirement: state => state.subscription.paymentRequirement,
        disablePayment: state => state.cartDetails.disablePayment
      }),

      ...mapState('culture', ['isDisplayTax']),

      navCount () {
        if (this.disablePayment) {
          return 2
        } else {
          return 3
        }
      },

      eabledButton () {
        if (!this.hasSubscription && this.isAuthenticated && !this.hasAddress && !this.isShow) {
          if (!this.hasBillingAddress) {
            if (this.currentCountryCode === 'US' || this.currentCountryCode === 'CA') {
              return !!this.addition && !!this.zipCode && !!this.city && !!this.selectedCountryState
            } else if (this.currentCountryCode === 'GB') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.county
            } else if (this.currentCountryCode === 'ES') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.stateCode && !!this.houseNumber
            } else if (this.currentCountryCode === 'BE') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.houseNumber
            } else if (this.currentCountryCode === 'IT') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.houseNumber && !!this.selectedCountryState
            } else if (this.currentCountryCode === 'RO') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.stateCode && !!this.houseNumber
            } else if (this.currentCountryCode === 'CZ') {
              return !!this.line1 && !!this.zipCode && !!this.city  && !!this.houseNumber  
            } else if (this.currentCountryCode === 'PL') {
              return !!this.street && !!this.houseNumber && !!this.zipCode && !!this.city
            } else if (this.currentCountryCode === 'DE') {
              return !!this.addition && !!this.zipCode && !!this.city
            } else if (this.currentCountryCode === 'NL') {
              return !!this.street && !!this.houseNumber && !!this.zipCode && !!this.city
            } else if (this.currentCountryCode === 'FR') {
              return !!this.line1 && !!this.zipCode && !!this.city  && !!this.houseNumber
            } else if (this.currentCountryCode === 'SE') {
              return !!this.line1 && !!this.zipCode && !!this.city  && !!this.houseNumber    
            } else if (this.currentCountryCode === 'AT') {
              return !!this.line1 && !!this.zipCode && !!this.city  && !!this.houseNumber
            }
          } else {
            if (this.currentCountryCode === 'US' || this.currentCountryCode === 'CA') {
              return !!this.addition && !!this.zipCode && !!this.city && !!this.selectedCountryState && !!this.billingAddition && !!this.billingZipCode && !!this.billingCity && !!this.selectedBillingCountryState
            } else if (this.currentCountryCode === 'ES') {
              return !!this.line1 && !!this.houseNumber && !!this.zipCode && !!this.city && !!this.stateCode && !!this.billingLine1 && !!this.billingHouseNumber && !!this.billingZipCode && !!this.billingCity && !!this.billingStateCode
            } else if (this.currentCountryCode === 'BE') {
              return !!this.line1 && !!this.houseNumber && !!this.zipCode && !!this.city && !!this.billingLine1 && !!this.billingHouseNumber && !!this.billingZipCode && !!this.billingCity  
            } else if (this.currentCountryCode === 'IT') {
              return !!this.line1 && !!this.houseNumber && !!this.zipCode && !!this.city && !!this.selectedCountryState && !!this.billingLine1 && !!this.billingHouseNumber && !!this.billingZipCode && !!this.billingCity && !!this.selectedBillingCountryState
            } else if (this.currentCountryCode === 'RO') {
              return !!this.line1 && !!this.houseNumber && !!this.zipCode && !!this.city && !!this.billingLine1 && !!this.billingHouseNumber && !!this.billingZipCode && !!this.billingCity 
            } else if (this.currentCountryCode === 'CZ') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.billingLine1 && !!this.billingZipCode && !!this.billingCity && !!this.billingHouseNumber
            } else if (this.currentCountryCode === 'GB') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.county && !!this.billingLine1 && !!this.billingZipCode && !!this.billingCity && !!this.billingCounty
            } else if (this.currentCountryCode === 'PL') {
              return !!this.street && !!this.houseNumber && !!this.zipCode && !!this.city && !!this.billingStreet && !!this.billingHouseNumber && !!this.billingZipCode && !!this.billingCity
            } else if (this.currentCountryCode === 'DE') {
              return !!this.addition && !!this.zipCode && !!this.city && !!this.billingAddition && !!this.billingZipCode && !!this.billingCity
            } else if (this.currentCountryCode === 'NL') {
              return !!this.street && !!this.houseNumber && !!this.zipCode && !!this.city && !!this.billingStreet && !!this.billingHouseNumber && !!this.billingZipCode && !!this.city && !!this.billingCity
            } else if (this.currentCountryCode === 'FR') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.billingLine1 && !!this.billingZipCode && !!this.billingCity && !!this.billingStateCode
            } else if (this.currentCountryCode === 'SE') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.billingLine1 && !!this.billingZipCode && !!this.billingCity && !!this.billingStateCode    
            } else if (this.currentCountryCode === 'AT') {
              return !!this.line1 && !!this.zipCode && !!this.city && !!this.billingLine1 && !!this.billingZipCode && !!this.billingCity  
            } 
          }
        }
      }
    },

    methods: {
      trackErrorFormFields () {
        let description = ''
        const formFields = remove(Object.keys(this.$v), item => !startsWith(item, '$'))

        formFields.forEach((field, index) => {
          if (!this.$v[field]) return

          if (this.$v[field].$invalid) {
            switch (field) {
              case 'selectedCountry':
                field = 'country'
                break
              case 'selectedCountryState':
                field = 'state'
                break
              case 'selectedBillingCountry':
                field = 'billingCountry'
                break
              case 'selectedBillingCountryState':
                field = 'billingState'
                break
            }
            description = `${description}${field.replace(/([A-Z])/g, '_$1').toLowerCase()}|`
          }
        })
        this.trackConversion({ name: 'validation_error', description: description.slice(0, -1) })
      },

      additionalActions () {
        try {
          this.$store.commit('account/setAddressArray', this.normalizedAddress)
          this.$bus.$emit('scroll-next-step', '[data-scroll="paymentMethod"]', -95)
          if (this.isDisplayTax && (!this.paymentRequirement || this.paymentRequirement === 'FirstTerm') && (!this.disablePayment)) {
            this.$store.dispatch('checkout/getCartDetails', {
              bundles: this.bundlesWithQuantity,
              excludePrice: false
            }).then((data) => {
              this.$store.commit('checkout/setCartDetails', data)
              this.$store.commit('checkout/setSubscriptionIsPreviewing', false)
            })
          }
        } catch (error) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(error)
          })
        }
      },

      showLabel () {
        this.showSelectLabel = true
      },

      validenableDisplayLabel () {
        if (this.selectedCountryState || this.selectedCountryProvince || this.county || this.selectedBillingCountryState || this.billingCounty) {
          this.showSelectLabel = true
        } else {
          this.showSelectLabel = false
        }
      },

      mouseleave (isBilling) {
        if (isBilling && !this.selectedBillingCountryProvince) {
          this.isBillingOpen = false
        }

        if (!isBilling && !this.selectedCountryProvince) {
          this.isOpen = false
        }
      },
      mouseover (isBilling) {
        if (isBilling && !this.selectedBillingCountryProvince) {
          this.isBillingOpen = true
        }

        if (!isBilling && !this.selectedCountryProvince) {
          this.isOpen = true
        }
      }
    }
  }
</script>

<style lang="scss">
.ReShippingAddress {
  border-bottom: .01rem solid #d6d6d6;

  .modal-button-wrapper {
    display: flex;
    overflow: hidden;

    .AppButton {
      margin-right: 0.2rem;
    }
  }

  .codeRed {
    color: #e60000;
  }

  .ShippingAddress_body {
    .SelectGroup {
      height: .56rem;
    }

    .city_poptip > div {
      width: 100%;
      height: .56rem;
    }

    .ShippingAddress_form {
      padding-bottom: 0;

      .multiselect--active {
        z-index: auto;

        .multiselect__tags {
          .multiselect__input {
            width: 100% !important;
          }
        }
      }

      .multiselect__tags {
        border: 0.01rem solid #d6d6d6;
        height: .56rem;
        padding-top: .13rem;
      }

      .multiselect.extend {
        position: relative;
        top: -.17rem;

        .multiselect__tags {
          padding-top: .24rem;
        }
      }

      .multiselect__select {
        top: 60%;
      }

      .typo__label {
        position: relative;
        z-index: 2;
        top: .09rem;
        left: .12rem;
        font-size: .12rem;
        line-height: .18rem;
        color: #9b9b9b;
      }

      .usDeliverAddress {
        &_label {
          @include media(tablet) {
            display: flex;
            justify-content: space-between;
          }

          .deliverAddress_zipCode {
            @include media(tablet) {
              width: 27%;
            }
          }

          .deliverAddress_city {
            @include media(tablet) {
              width: 41%;
            }
          }

          .deliverAddress_states {
            @include media(tablet) {
              width: 27%;
            }
          }
        }
      }

      .gbDeliverAddress {
        &_topLabel {
          @include media(tablet) {
            display: flex;
            justify-content: space-between;
          }

          .deliverAddress {
            &_line1 {
              @include media(tablet) {
                width: 49%;
              }
            }

            &_houseNumber {
              @include media(tablet) {
                width: 48%;
              }
            }

            &_line2 {
              @include media(tablet) {
                width: 48%;
              }
            }
          }
        }

        &_belowLabel {
          @include media(tablet) {
            display: flex;
            justify-content: space-between;
          }

          .deliverAddress_zipCode {
            @include media(tablet) {
              width: 40%;
            }
          }

          .deliverAddress_city {
            @include media(tablet) {
              width: 25%;
            }
          }

          .deliverAddress_country {
            @include media(tablet) {
              width: 30%;
            }
          }
        }
      }

      .esDeliverAddress {
        &_topLabel {
          @include media(tablet) {
            display: flex;
            justify-content: space-between;
          }

          .deliverAddress {
            &_line1 {
              @include media(tablet) {
                width: 37%;
              }
            }

            &_houseNumber {
              @include media(tablet) {
                width: 21%;
              }
            }

            &_line2 {
              @include media(tablet) {
                width: 37%;
              }
            }
          }
        }

        &_belowLabel {
          @include media(tablet) {
            display: flex;
            justify-content: space-between;
          }

          .deliverAddress_zipCode {
            @include media(tablet) {
              width: 40%;
            }
          }

          .deliverAddress_city {
            @include media(tablet) {
              width: 25%;
            }
          }

          .deliverAddress_county {
            @include media(tablet) {
              width: 30%;
            }
          }

          .deliverAddress_country {
            @include media(tablet) {
              width: 30%;
            }
          }
        }
      }

      .deDeliverAddress {
        &_belowLabels {
          @include media(tablet) {
            display: flex;
            justify-content: space-between;
          }

          .deliverAddress {
            &_zipCode {
              @include media(tablet) {
                width: 49%;
              }
            }

            &_city {
              @include media(tablet) {
                width: 48%;
              }
            }
          }
        }
      }

      .nlDeliverAddress {
        &_topLabel {
          @include media(tablet) {
            justify-content: space-between;
          }

          .deliverAddress {
            &_street {
              @include media(tablet) {
                width: 53%;
              }
            }

            &_houseNumber {
              @include media(tablet) {
                width: 21%;
              }
            }

            &_extension {
              @include media(tablet) {
                width: 21%;
              }
            }
          }
        }

        &_belowLabel {
          width: 100%;

          @include media(tablet) {
            justify-content: space-between;
          }

          .deliverAddress {
            &_zipCode {
              @include media(tablet) {
                width: 69%;
              }
            }

            &_city {
              @include media(tablet) {
                width: 28%;
              }
            }
          }
        }
      }

      .plDeliverAddress {
        &_topLabel {
          @include media(tablet) {
            justify-content: space-between;
          }

          .deliverAddress {
            &_addition {
              @include media(tablet) {
                width: 75%;
              }
            }

            &_houseNumber {
              @include media(tablet) {
                width: 23%;
              }
            }
          }
        }

        &_belowLabel {
          @include media(tablet) {
            justify-content: space-between;
          }

          .deliverAddress {
            &_extension {
              @include media(tablet) {
                width: 41%;
              }
            }

            &_zipCode {
              @include media(tablet) {
                width: 27%;
              }
            }

            &_city {
              @include media(tablet) {
                width: 27%;
              }
            }
          }
        }
      }

      .Form_group-choice {
        margin-top: .35rem;
        margin-bottom: 0;

        @include media(tablet) {
          margin-top: 0;
        }
      }
    }

    .AppButton {
      margin-top: .35rem;
      margin-bottom: .175rem;

      @include media(tablet) {
        width: auto !important;
        padding: .09rem .81rem;
        margin-bottom: .14rem;
        margin-top: .18rem;
      }
    }

    .hide_select {
      .multiselect__select {
        display: none;
      }
    }

    .billingAddress_form {
      .multiselect__placeholder {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        -webkit-line-clamp: 1;
      }

      .typo__label {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 93%;
        -webkit-line-clamp: 1;
      }

      .SelectGroup {
        .tip-error {
          margin-top: -.17rem;
        }
      }
    }
  }

  .ShippingAddress_header {
    padding: .175rem 0 .175rem .12rem;
    font-size: .24rem;
    line-height: .31rem;

    .title {
      font-weight: 700;
    }
  }

  .multiselect__single {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .width30 {
    width: 30%;
  }
}
</style>
